import styled from 'styled-components'

export const TextWithIconTooltipWrapper = styled.div<{ $gap: number }>`
  display: flex;
  align-items: center;
  gap: ${({ $gap }) => $gap}px;
`
